export const CALENDAR = "calendar";
export const LIST = "list";
export const FEED = "feed";
export const DRAFTS = "drafts";
